export const SEARCH_FILTER_SHOW_STATUS = {
  ALL: 'all',
  MY: 'my',
  SP: 'sp',
  SHARED: 'shared',
};
